export const formatFileSize = (bytes) => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0B'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
  return `${parseFloat((bytes / 1024 ** i).toFixed(0))} ${sizes[i]}`
}
